import { render, staticRenderFns } from "./TransactionDeclined.vue?vue&type=template&id=506a9da6&scoped=true"
import script from "./TransactionDeclined.vue?vue&type=script&lang=js"
export * from "./TransactionDeclined.vue?vue&type=script&lang=js"
import style0 from "./TransactionDeclined.vue?vue&type=style&index=0&id=506a9da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a9da6",
  null
  
)

export default component.exports